/* lib dropdowns
 ========================================================================== */
// vendors
// @ts-ignore
import Dropdowns from 'a11y-dropdown-component';
// init dropdowns based on data components
export function initDropdowns() {
    Dropdowns.init();
}
export default function addDropdown(id, { breakpoint = null, breakpointPlus = false, hover = false, autoClose = false } = {}) {
    const dropdown = document.getElementById(id);
    let isCreated = false;
    if (!dropdown)
        return;
    const createDropdown = () => {
        Dropdowns.render(id, {
            hover,
            autoClose,
        });
    };
    const destroyDropdown = () => {
        Dropdowns.destroy(id);
    };
    const setDropdownAbove = () => {
        if (window.innerWidth > breakpoint && !isCreated) {
            isCreated = true;
            createDropdown();
        }
        else if (window.innerWidth <= breakpoint && isCreated) {
            isCreated = false;
            destroyDropdown();
        }
    };
    const setDropdownBelow = () => {
        if (window.innerWidth <= breakpoint && !isCreated) {
            isCreated = true;
            createDropdown();
        }
        else if (window.innerWidth > breakpoint && isCreated) {
            isCreated = false;
            destroyDropdown();
        }
    };
    const onLoad = () => {
        breakpointPlus ? setDropdownAbove() : setDropdownBelow();
    };
    const onResize = () => {
        breakpointPlus ? setDropdownAbove() : setDropdownBelow();
    };
    if (breakpoint) {
        window.addEventListener('load', onLoad);
        window.addEventListener('resize', onResize);
    }
    else {
        createDropdown();
    }
}
